import { useState, useEffect } from "react";

export function useUserMedia(videoRef,requestedMedia) {
  const [mediaStream, setMediaStream] = useState(null);

  useEffect(() => {
    async function enableStream() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia(requestedMedia);
        if(videoRef.current && !mediaStream)
        {
          videoRef.current.srcObject = stream;
          setMediaStream(stream);
        }
      } 
      catch(err) 
      {
        console.log(err)
      }
    }

    if (!mediaStream && requestedMedia ) {
        enableStream();
    } 
    else if (!requestedMedia)
    {
      return function cleanup() {
        mediaStream.getTracks().forEach(track => {
          track.stop();
        });
      }
    }
  }, [mediaStream, requestedMedia]);

  return [mediaStream,setMediaStream,videoRef.current];
}
